import { useMemo } from 'react';
import useAuthenticatedFetchClient from '../Hooks/UseAuthenticatedFetchClient';
import FetchClient from '@cb/common-ts/FetchClient';
export class ObjectStorageService {
    fetchClient;
    constructor(fetchClient) {
        this.fetchClient = fetchClient;
    }
    async getPresignedUrlForUpload(filePath, contentType) {
        const request = this.fetchClient.postJson(`ObjectStorage/presigned/upload`, {
            filePath,
            contentType,
        });
        const response = await request.response;
        return response.url;
    }
    async getPresignedUrlForDownload(filePath) {
        const request = this.fetchClient.postJson(`ObjectStorage/presigned/download`, {
            filePath,
        });
        const response = await request.response;
        return response.url;
    }
    async upload(filePath, file) {
        const formData = new FormData();
        formData.append('file', file);
        const request = this.fetchClient.put(`ObjectStorage/upload/${filePath}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const response = await request.response;
        if (response.status !== 200) {
            throw new Error('Failed to upload file');
        }
    }
    async download(filePath) {
        const request = this.fetchClient.get(`ObjectStorage/download/${filePath}`);
        const response = await request.response;
        if (response.status < 200 || response.status >= 400) {
            throw new Error('Failed to download file');
        }
    }
    getRedirectUrl(filePath) {
        return `ObjectStorage/redirect/${filePath}`;
    }
    getDownloadUrl(filePath) {
        return `ObjectStorage/download/${filePath}`;
    }
    async uploadViaPresignedUrl(filePath, file) {
        const url = await this.getPresignedUrlForUpload(filePath, file.type);
        // Use a new fetch client because we don't want our auth token injected (will cause errors)
        const fetchClient = new FetchClient();
        const request = fetchClient.put(url, file, {
            headers: {
                'Content-Type': file.type,
            },
        });
        const response = await request.response;
        if (response.status < 200 || response.status >= 400) {
            throw new Error('Failed to upload file');
        }
    }
}
export function useObjectStorageService() {
    const fetchClient = useAuthenticatedFetchClient();
    const objectStorageService = useMemo(() => new ObjectStorageService(fetchClient), [fetchClient]);
    return objectStorageService;
}
//# sourceMappingURL=ObjectStorageService.js.map